import { dayInMilliseconds, evaluationOptOutCookieName, evaluationOptOutDurationInDays } from './constants'

export const getEvaluationOptOutExpirationDate = date => {
  return new Date(date.getTime() + evaluationOptOutDurationInDays * dayInMilliseconds)
}

export const saveEvaluationOptOut = expirationDate => {
  document.cookie = `${evaluationOptOutCookieName}=true; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`
}

export const hasEvaluationOptOut = () => {
  return document.cookie.split('; ').includes(`${evaluationOptOutCookieName}=true`)
}
